import { render, staticRenderFns } from "./GenericLogoPage.vue?vue&type=template&id=7257f66b"
import script from "./GenericLogoPage.vue?vue&type=script&lang=js"
export * from "./GenericLogoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports